import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAddPerson = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 12,
	fill: "currentColor",
	viewBox: "0 0 16 12",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M10.182 5.818a2.908 2.908 0 1 0 0-5.818 2.908 2.908 0 1 0 0 5.818ZM3.636 4.364V2.182H2.182v2.182H0v1.454h2.182V8h1.454V5.818h2.182V4.364H3.636Zm6.546 2.909c-1.942 0-5.818.974-5.818 2.909v1.454H16v-1.454c0-1.935-3.876-2.91-5.818-2.91Z" })
});
export default SvgAddPerson;
